module.exports = __webpack_public_path__ + "img/02.33330be0.png";